<label class="fieldset-label flex gap-2 items-center select-none">
  <input
    [(ngModel)]="value"
    [ngClass]="[currentColor(), currentSize()]"
    type="checkbox"
    checked="checked"
    class="checkbox border-neutral-300! checked:bg-white checked:text-primary-500 checked:border-primary-500! rounded size-5"
  />
  @if (label(); as label) {
  <p class="text-gray-800 font-normal">{{ label }}</p>
  } @else {
  <p class="text-gray-800 font-normal"><ng-content /></p>
  }
</label>
